import React, { Context, createContext, PropsWithChildren, useContext, useMemo, useState } from 'react'
import { IPageLeave, TConditions, TPageLeaveActions } from '../types'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import usePageLeave from '../../hooks/usePageLeave'
import { Modal } from 'antd'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const { confirm } = Modal

const initialPageLeaveState: IPageLeave = {
	conditions: {},
	condition: false,
}

const PageLeaveContext: Context<{
	pageLeave: IPageLeave
	actions: TPageLeaveActions
}> = createContext({
	pageLeave: {
		...initialPageLeaveState,
	},
	actions: {
		setConditions: (conditions: TConditions) => {},
		showConfirm: (unblockCb: () => void) => {},
	},
})

export const PageLeaveProvider = (props: PropsWithChildren<{}>) => {
	const [conditions, setConditions] = useState<TConditions>(initialPageLeaveState.conditions)

	const showConfirm = (unblockCb: () => void) => {
		confirm({
			title: 'Are you sure you want to leave?',
			icon: <ExclamationCircleOutlined />,
			content: 'Changes you have made may not be saved.',
			okText: 'Leave',
			onOk() {
				unblockCb()
			},
		})
	}

	const condition = useMemo(
		() => Object.keys(conditions).reduce((res: boolean, key: string) => res || conditions[key], false),
		[conditions]
	)

	usePageLeave({
		callback: (unblockCb) => {
			showConfirm(unblockCb)
			return false
		},
		condition,
	})

	const actions: TPageLeaveActions = { setConditions, showConfirm }

	return (
		<PageLeaveContext.Provider value={{ pageLeave: { conditions, condition }, actions }}>
			{props.children}
		</PageLeaveContext.Provider>
	)
}

export const usePageLeaveContext: () => { pageLeave: IPageLeave; actions: TPageLeaveActions } = () => {
	return useContext(PageLeaveContext)
}
